import ProjectSubmissionMetaModalModule from './submission-meta-modal.module'

export default ProjectSubmissionMetaModalModule
